import { render, staticRenderFns } from "./RoutinePickPlan.vue?vue&type=template&id=2bff0718&scoped=true"
import script from "./RoutinePickPlan.vue?vue&type=script&lang=js"
export * from "./RoutinePickPlan.vue?vue&type=script&lang=js"
import style0 from "./RoutinePickPlan.vue?vue&type=style&index=0&id=2bff0718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bff0718",
  null
  
)

export default component.exports